import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { FirmService } from '../../../../Services/firm.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../../Services/auth.service';
import { NotificationService } from '../../../../Services/notification.service';
import { UserAccessService } from '../../../../Services/UserAccess/user-access.service';

@Component({
  selector: 'app-invoice-gst-header',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, NgIf],
  templateUrl: './invoice-gst-header.component.html',
  styleUrl: './invoice-gst-header.component.css'
})
export class InvoiceGstHeaderComponent implements OnInit {

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;

  router = inject(Router);
  menuOpen = false;
  mobileExpanded: string | null = null;
  userSubRole: any;
  isFirmLocked: boolean = false;

  // All possible menu options — visibility controlled by DB permissions
  private allNavbarOptions = [
    {
      lable: 'GST Bill',
      path: '/invoice-gst-panel',
      visible: false,
      submenu: [
        // { path: '/invoice-gst-panel', lable: 'GST Invoice List', visible: false },
        // { path: '/invoice-gst', lable: 'GST Invoice Preview', visible: false }
      ]
    },
    {
      lable: 'Purchase Bill',
      path: '/purchase-bill',
      visible: false,
      submenu: [
        // { path: '/purchase-bill', lable: 'Purchase Bill Form', visible: false }
      ]
    },
    {
      lable: 'Reports',
      path: '/purchase-report',
      visible: false,
      submenu: [
        { path: '/purchase-report', lable: 'Purchase Bills', visible: false },
        { path: '/gst-bill-report', lable: 'GST Bills', visible: false }
      ]
    },
    {
      lable: 'Customers',
      path: '/gst-customer-list',
      visible: false,
      submenu: [
        // { path: '/gst-customer-list', lable: 'GST Customer List', visible: false }
      ]
    },
    {
      lable: 'Settings',
      path: '/gst-settings',
      visible: false,
      submenu: [
        // { path: '/gst-settings', lable: 'GST Settings', visible: false }
      ]
    },
    {
      lable: 'Accounts',
      path: '/accounts',
      visible: false,
      submenu: [
        // { path: '/accounts', lable: 'Accounts List', visible: false },
        // { path: '/account-ledger', lable: 'Account Ledger', visible: false }
      ]
    },
    {
      lable: 'Daybook',
      path: '/daybook',
      visible: false,
      submenu: [
        // { path: '/daybook', lable: 'Daybook', visible: false }
      ]
    },
    {
      lable: 'Trial Balance',
      path: '/trail-balance',
      visible: false,
      submenu: [
        // { path: '/trail-balance', lable: 'Trial Balance', visible: false }
      ]
    },
    {
      lable: 'Profile',
      path: '/ca-account',
      visible: false,
      submenu: []
    },
  ];

  navbarOptions: typeof this.allNavbarOptions = [];

  constructor(
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private userAccessService: UserAccessService
  ) { }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  toggleSubmenu(path: string) {
    this.mobileExpanded = this.mobileExpanded === path ? null : path;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;
    this.mobileExpanded = null;
  }

  ngOnInit(): void {
    this.loadFirms();
    this.getUserRole();

    const userRole = sessionStorage.getItem('role');
    this.isFirmLocked = (sessionStorage.getItem('is_firm_restricted') === 'true') || (userRole === 'Staff');

    // Subscribe to firm updates
    this.firmService.firmsUpdated$.subscribe(() => {
      this.loadFirms();
    });

    const userId = this.authService.getUserId();
    this.loadMenuFromPermissions(userId);
  }

  loadMenuFromPermissions(userId: any) {
    const userRole = this.authService.getUserRole();
    const isOwner = userRole?.toLowerCase() === 'owner';

    // Owner always has full access — skip DB permissions entirely
    if (isOwner) {
      this.navbarOptions = this.allNavbarOptions
        .filter(item => item.path !== '/ca-account')
        .map(item => ({ ...item, visible: true, submenu: item.submenu.map(s => ({ ...s, visible: true })) }));
      return;
    }

    this.userAccessService.getUserAccess(userId).subscribe({
      next: (res: any) => {
        const data = res?.data;
        const allowedPaths: string[] = [
          ...(data?.mainmenu_visibility || []),
          ...(data?.submenu_visibility || [])
        ].map((r: string) => (r.startsWith('/') ? r : '/' + r));

        this.navbarOptions = this.allNavbarOptions
          .map(item => ({
            ...item,
            visible: allowedPaths.some(p => p === item.path || p.startsWith(item.path + '/')),
            submenu: item.submenu.map(sub => ({
              ...sub,
              visible: allowedPaths.includes(sub.path)
            }))
          }))
          .filter(item => item.visible);
      },
      error: () => {
        this.navbarOptions = [];
      }
    });
  }

  getUserRole() {
    this.userSubRole = this.authService.getUserSubRole();
  }

  onFirmChange(name: string) {
    this.firmService.getFirms().subscribe((response: any) => {
      const firm = response.data.find((f: any) => f.name === name);
      if (firm) {
        this.firmSelectionService.setselectedFirmName({ id: firm.id, name: firm.name, status: firm.gst_status, });
      }
    });
  }

  private loadFirms() {
    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((firm: any) => firm.name);

      // Reflect current selection
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) {
          this.selectedFirm = firm.name;
        }
      });
    });
  }
  isUserMenuOpen = false;

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;

    if (!currentTarget) {
      this.isUserMenuOpen = false;
      return;
    }

    // ✅ Close only if focus moved outside the wrapper
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.isUserMenuOpen = false;
    }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess(
      'Logged out successfully.',
      'Logout'
    );
    this.authService.logout();
  }
}